export const getCardShare = (text, spiteDetails = '') => (
  <div className="tw-flex tw-items-center tw-gap-[10px]">
    {!!spiteDetails && <div className={`wb-sprite ${spiteDetails}`} />}
    <div>{text}</div>
  </div>
);
